import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'

export interface AdminUserDetail {
  id: number
  uuid: string
  apple_id: {
    phone_number: string
    active: boolean
  } | null
}

const fetchAdminUserDetail = async (
  userId: string | number
): Promise<AdminUserDetail> => {
  let response = await fetch(`${BASE_API_URL}/admin/api/v1/users/${userId}`, {
    method: API_METHODS.GET,
    headers: apiHeaders(store.getState()),
  })
  response = handleErrors(response)
  return response.json()
}

export const isBlueUser = (detail?: AdminUserDetail) =>
  !!detail?.apple_id && detail.apple_id.active === true

const useAdminUserDetail = (userId: string | number | undefined) => {
  return useQuery(
    ['admin/api/v1/users/detail', userId],
    () => fetchAdminUserDetail(userId!),
    {
      enabled: userId !== undefined && userId !== null && userId !== '',
    }
  )
}

export default useAdminUserDetail
